<div class="breadcrumb-area">
	<h1>Roles y permisos</h1>
</div>
<div class="card">
	<div class="card-header">
		<h3>1. Selecciona el rol a modificar</h3>
	</div>
	<div class="card-body">
		<span class="display-4"></span>
		<div class="form-group">
			<label for="rol-input" class="form-label">Rol</label>
			<div class="input-group input-group-sm">
				<app-input-autocomplete [allBorderRadius]="true" [inputs]="inputs.rol"
					[placeholder]="'Ingresa o crea un rol'" [filterElements]="rolesFilter" [typeElements]="'rol'"
					(changeMethod)="verifiedInput($event.event,'rol')" (inputMethod)="handleInput($event.event,'rol')"
					(getTitle)="$event.filterElement.title = $event.filterElement.name"
					(changeStatus)="changeStatusInput($event.filterElement,$event.filterElement.name,1,'rol')"></app-input-autocomplete>
			</div>
		</div>
		<span class="text-muted" *ngIf="!inputs.rol.verified && inputs.rol.value"><i
				class="fa fa-warning text-warning"></i>El
			rol <b style="font-weight: 900;">{{inputs.rol.value}}</b> aún no existe, dirijase a Recursos Humanos para
			crearlo</span>
		<span class="text-muted" *ngIf="inputs.rol.verified && this.creating"><i
				class="fa fa-circle-info text-info"></i>El
			rol <b style="font-weight: 900;">{{inputs.rol.value}}</b> aún no tiene permisos definidos</span>
		<!-- <div class="row" *ngIf="inputs.rol.class == 'fa-user-plus' && inputs.rol.verified">
			<div class="col-sm form-group">
				<label for="department" class="form-text">Departamento</label>
				<select name="department" id="department" class="form-select">
					<option value="0">Selecciona un valor</option>
					<option *ngFor="let deparment of departments" value="{{deparment.id}}">{{deparment.name}}</option>
				</select>
			</div>
			<div class="col-sm form-group">
				<label for="boss" class="form-text">Jefe</label>
				<select name="boss" id="boss" class="form-select">
					<option value="0">Selecciona un jefe inmediato</option>
					<option *ngFor="let rol of roles" value="{{rol.id}}">{{rol.name}}</option>
				</select>
			</div>
		</div> -->
	</div>
</div>
<div class="card mt-3 container-alert-div" [class.blur]="!inputs.rol.verified">
	<div class="card-header">
		<h3>2. {{inputs.rol.verified?'Asigna los permisos al rol ':'Asignación de permisos'}}
			<b>{{inputs.rol.verified?inputs.rol.value:''}}</b>
		</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col">
				<span class="text-muted">Se muestran los posibles permisos que puedes otorgar, se pondrán en <u
						style="font-weight: 900; color: green;">verde</u> los permisos asignados</span>
			</div>
			<div class="col" style="display: flex;">
				<button [ngClass]="allPerms?'btn-success':''" class="btn all-perms" (click)="selectAllPerms()">
					<i [ngClass]="allPerms?'fa-solid fa-square-check':'fa-regular fa-square'"></i>
					OTORGAR TODOS LOS PERMISOS
				</button>
			</div>
		</div>
		<div class="accordion accordion-flush mb-3" id="accordion-permissions">
			<div class="accordion-item" *ngFor="let perms of listAllPermissions">
				<h2 class="accordion-header">
					<button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
						[attr.data-bs-target]="'#'+perms.class+'-permissions'" aria-expanded="false"
						[attr.aria-controls]="perms.class+'-permissions'">
						<i class="fa {{perms.icon}}"></i> {{perms.placeholder}}
					</button>
				</h2>
				<div id="{{perms.class}}-permissions" class="accordion-collapse collapse"
					[attr.data-bs-parent]="'#accordion-permissions'">
					<div class="table-responsive" style="padding: 1em;">
						<table class="table table-striped">
							<thead>
								<tr><!-- 
									<th>ID</th> -->
									<th>Nombre</th>
									<th>Crear</th>
									<th>Editar</th>
									<th>Leer</th>
									<th>Borrar</th>
								</tr>
							</thead>
							<tbody>
								<tr id="{{invPermissions.id}}" *ngFor="let invPermissions of perms.permissions"><!-- 
									<td>{{invPermissions.id}}</td> -->
									<td>{{invPermissions.name}}</td>
									<td class="check" (click)="changePermission('create',invPermissions)">
										<a [class.checked]="invPermissions.permission.create"><i
												class="fa fa-plus"></i></a>
									</td>
									<td class="check" (click)="changePermission('update',invPermissions)">
										<a [class.checked]="invPermissions.permission.update"><i
												class="fa fa-edit"></i></a>
									</td>
									<td class="check" (click)="changePermission('read',invPermissions)">
										<a [class.checked]="invPermissions.permission.read"><i
												class="fa fa-eye"></i></a>
									</td>
									<td class="check" (click)="changePermission('delete',invPermissions)">
										<a [class.checked]="invPermissions.permission.delete"><i
												class="fa fa-trash"></i></a>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
		<div><button class="btn btn-success" style="width: 100%;" (click)="savePermissions()"> <i
					class="fa fa-floppy-disk"></i>
				GUARDAR CAMBIOS</button></div>
	</div>
	<div class="alert-div" *ngIf="!inputs.rol.verified">
		<span class="display-3 text-info"><i class="fa fa-circle-info"></i>Selecciona un rol primero</span>
	</div>
</div>